import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    Route, Switch,
} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { getTranslate } from 'react-localize-redux';

// import Login from './components/Login';
// import Logout from './components/Logout';
// import ResetPassword from './components/ResetPassword';
// import ForgotPassword from './components/ForgotPassword';
import urls from '../../app/urls';
import { scrollerWidth } from '../../app/style/theme';
import { heightBreak } from './components/constants';
import { ErrorBoundary } from '../../youwell-common/components';
import CountrySelect from './CountrySelect';
import GoToCountry from './GoToCountry';
// import SelectOrg from './components/SelectOrg';

const topPadding = 200;
const topPaddingHeightBreak = 280;

const styles = theme => ({
    root: {
        position: 'relative',
        margin: '0 auto',
        height: '100%',
        width: '100%',
        border: theme.youwell.borders.dim,
        background: theme.palette.background.default,
        overflow: 'hidden',

        [theme.breakpoints.down('xs')]: {
            border: 'none',
            height: 'auto',
            overflow: 'auto',
        },

        [theme.breakpoints.up('lg')]: {
            width: theme.breakpoints.values.lg - scrollerWidth,
        },
    },
    header: {
        height: topPadding,
        background: theme.palette.background.inner,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        paddingBottom: theme.spacing(5),

        [heightBreak]: {
            height: topPaddingHeightBreak,
        },

        [theme.breakpoints.down('xs')]: {
            height: 'auto',
            paddingBottom: 0,
        },

    },
    titleLogo: {
        maxHeight: 180,
        maxWidth: 500,

        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(4),
            maxHeight: 100,
            maxWidth: '90%',
        },
    },
    appTitle: {
        fontWeight: theme.typography.fontWeightMedium,
        paddingTop: 100,
        color: theme.palette.primary.main,

        [theme.breakpoints.down('xs')]: {
            paddingTop: 50,
        },
    },
    content: {
        width: 500,
        position: 'absolute',
        zIndex: 10,
        top: topPadding,
        left: '50%',
        backgroundImage: 'linear-gradient(to bottom, white 30%, rgba(255,255,255,0))',
        background: theme.palette.common.white,
        transform: 'translate(-50%, 0)',
        border: theme.youwell.borders.dim,
        borderRadius: 24,
        padding: theme.spacing(4),
        boxShadow: theme.shadows[5],
        minHeight: 300,
        maxHeight: `calc(100vh - ${topPadding}px - 50px)`,
        overflowY: 'auto',

        [heightBreak]: {
            maxHeight: `calc(100vh - ${topPaddingHeightBreak}px - 50px)`,
            top: topPaddingHeightBreak,
        },

        [theme.breakpoints.down('xs')]: {
            position: 'relative',
            width: '100%',
            left: 0,
            top: 0,
            transform: 'none',
            border: 0,
            borderRadius: 0,
            padding: theme.spacing(2),
            boxShadow: 'none',
            minHeight: 'auto',
            maxHeight: 'none',
            overflowY: 'inherit',
        },
    },
    errorMessage: {
        marginTop: theme.spacing(2),
    },
    appError: {
    },
});

class Index extends React.Component {
    render() {
        const { classes, appConfig } = this.props;

        const defaultPage = appConfig.language ? GoToCountry : CountrySelect;

        return (
            <div className={classes.root}>
                {/* <ErrorBoundary id="Outside_Header">
                    <div className={classes.header}>
                        {appConfig.titleLogo ? (
                            <Image src={appConfig.titleLogo} className={classes.titleLogo} />
                        ) : (
                            <Typography noWrap variant="h5" className={classes.appTitle}>
                                {translate('header.title')}
                            </Typography>
                        )}
                    </div>
                </ErrorBoundary> */}

                <div className={classes.content}>
                    <ErrorBoundary id="Outside_Content">
                        <Switch>
                            <Route exact path={`${urls.home}/:redirect?`} component={defaultPage} />
                            <Route exact path={`${urls.login}/:redirect?`} component={defaultPage} />
                            {/* <Route exact path={`${urls.accessKeyLogin}/:accessKey`} component={Login} />
                            <Route exact path={`${urls.logout}/:reason?`} component={Logout} />
                            <Route exact path={`${urls.login}/${urls.loginParts.resetPassword}/:token`} component={ResetPassword} />
                            <Route exact path={`${urls.login}/${urls.loginParts.forgotPassword}`} component={ForgotPassword} />
                            <Route exact path={`${urls.login}/${urls.loginParts.selectOrg}`} component={SelectOrg} />
                            <Route exact path={`${urls.login}/${urls.loginParts.accessCode}/:provider/:code/:state?/:appParameters?`} component={Login} />
                            <Route exact path={`${urls.login}/${urls.loginParts.external}/:redirect?`} component={Login} />
                            <Route exact path={`${urls.login}/:redirect?`} component={Login} /> */}
                            <Route component={defaultPage} />
                        </Switch>
                        <div className={classes.errorMessage}>
                            <Typography variant="subtitle2" color="error" className={classes.appError} display="block" align="center">
                                {appConfig.appError}
                            </Typography>
                        </div>
                    </ErrorBoundary>
                </div>
            </div>
        );
    }
}

Index.propTypes = {
    classes: PropTypes.object.isRequired,
    appConfig: PropTypes.object.isRequired,
    // translate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    appConfig: state.pageSettings.appConfig,
});

export default connect(mapStateToProps)(withStyles(styles)(Index));
